// src/components/AgeretProductDetail.jsx

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/New-Products/hYDEW-PM.jpg";
import thumb1 from "../assets/images/All-Products/hydewpm2.png";
import thumb2 from "../assets/images/New-Products/hYDEW-PM.jpg";
import thumb3 from "../assets/images/All-Products/hydew.png";
import howToUseThumb from "../assets/images/skin-breadcrum.jpg";
import howToUseVideo from "../assets/Video/meical video.mp4";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";



const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("benefits");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Empowering Confidence Through Skin Health."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Skin Care", to: "/Skin-Care-Products" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb1, thumb2].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>Hydew PM</h2>
              <p className="sub-heading text-muted">Skin repair with Neurocosmetic</p>
              <h5>Product Overview</h5>
              <p>
                A restoring neurocosmetic night moisturizer that goes beyond hydration to actively strengthen your skin barrier at a cellular level.
                A breakthrough in skincare, designed using neuroscience-backed molecules to harness the brain-skin connection for superior healing and rejuvenation,
                restore hydration, reduce fine lines, and boost skin elasticity. Infused with a powerful blend of neuropeptides, antioxidants, and botanical extracts,
                it helps reduce the appearance of fine lines and combats environmental stressors. It works to revitalize, nourish, and protect, ensuring your skin awakens refreshed, radiant, and rejuvenated.
              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">Hydew PM?</span>
                </h3>
                <p>
                  Use at night time after cleansing, take 1-2 pumps of moisturizer
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["benefits", "application", "ingredients", "precautions", "recommended"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "benefits"
                    ? "BENEFITS"
                    : tab === "application"
                      ? "APPLICATION GUIDELINES"
                      : tab === "ingredients"
                        ? "INGREDIENTS"
                        : tab === "recommended"
                          ? "RECOMMENDED FOR"
                          : tab === "precautions"
                            ? "PRECAUTIONS"
                            : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "benefits" && (
                <div className="tab-content fade-in">
                  <ul>
                    <li>Paraben and Silicon free.</li>
                    <li>Instant hydration and soothing effect.</li>
                    <li>Neuroscience backed molecules.</li>
                    <li>Vegan and Natural.</li>
                    <li>Preserves the skin’s natural barrier.</li>
                    <li>Gives radiant and youthful skin.</li>
                  </ul>

                </div>
              )}
              {activeTab === "application" && (
                <div className="tab-content fade-in">
                  <p>
                    <ol>
                      <li>Use at night time after cleansing.</li>
                      <li>Take 2 finger-tip units of Hydew PM on your palm.</li>
                      <li>Apply liberally and evenly on the face.</li>
                      <li>Massage gently for quick and even absorption.</li>
                    </ol>


                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>
                    <ol>
                      <li>
                        <strong>Hy Magic 4D:</strong> A combination of 4 kinds of HA that forms a 3-dimensional network and accurately targets different layers of the skin to replenish water from outside and hold water from inside.
                      </li>
                      <li>
                        <strong>Kannabia Sense:</strong> An innovative prebiotic treatment that activates the skin microbiome to generate postbiotics, boosting cutaneous oxytocin production. This enhances skin–brain communication, promoting a sense of well-being and resulting in healthier, stronger, and more radiant skin.
                      </li>
                      <li>
                        <strong>Bicowhite Complex:</strong> Multi-active bicosome complex that targets dermal epidermal pigmentation—melanin production, transfer, oxidation, inflammation, and cell renewal—by delivering actives precisely where they work best for synergistic results.
                      </li>
                      <li>
                        <strong>Perfection Peptide:</strong> A biologically active hepta-peptide that stimulates the skin's self-defense mechanisms against oxidative stress. It fights environmental and chronological aging, protects DNA from oxidation, neutralizes free radicals, and boosts the skin’s antioxidant capacity.
                      </li>
                      <li>
                        <strong>Ceramide Complex:</strong> Creates a water-impermeable protective barrier to prevent excessive moisture loss and block microorganism entry. It helps repair the skin barrier, improves hydration, and reduces TEWL.
                      </li>
                    </ol>
                  </p>
                </div>
              )}
              {activeTab === "recommended" && (
                <div className="tab-content fade-in">
                  <p>
                    <ol>
                      <li>Night-time skin repair & hydration</li>
                      <li>Compromised skin barrier</li>
                      <li>Post-procedure care</li>
                      <li>Sensitive or irritated skin</li>
                    </ol>


                  </p>
                </div>
              )}
              {activeTab === "precautions" && (
                <div className="tab-content fade-in">
                  <p>
                    <ol>
                      <li>Avoid contact with eyes and mucous membranes</li>
                      <li>For external use only</li>


                    </ol>

                  </p>
                </div>
              )}



            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
